import {ReactElement} from "react";
import {CustomZDDropdown} from "../../../atoms/custom-zd-dropdown/CustomZDDropdown";
import {updateTaxFilter} from "../logic";
import {TaxFilter, TaxFilterOptions} from "../types";
import "native-injects";

interface PayrollTaxPercentFilterProps {
    setTaxFilter: React.Dispatch<React.SetStateAction<TaxFilter>>;
    taxFilter: TaxFilter;
    taxFilterOptions: TaxFilterOptions;
    what: keyof TaxFilter;
}

export function PayrollTaxPercentFilter(props: PayrollTaxPercentFilterProps): ReactElement {
    const {setTaxFilter, taxFilter, taxFilterOptions, what} = props;
    let initialSelectedItems = ["any"];
    const filterValue = taxFilter[what];
    if (filterValue) {
        initialSelectedItems = [filterValue];
    }
    return (
        <CustomZDDropdown
            initialSelectedItems={initialSelectedItems}
            applySelectedItems={function (items: any): void {
                const selected = items.firstElement;
                if(selected == "any" || !selected) {
                    setTaxFilter(updateTaxFilter(taxFilter, what, undefined));
                }
                else {
                    setTaxFilter(updateTaxFilter(taxFilter, what, selected));
                }
            }}
            openDropdownPlaceholder={"Filter"}
            closedDropdownPlaceholder={undefined}
            options={taxFilterOptions[what]}
            isError={undefined}
        />
    )
}